import React from 'react';
import moment from 'moment-timezone';
import FixedView from '../FixedView';
import { checkTranslation, translate } from '../../utils/useful';
import TextInput from './TextInput';
import SelectInput from './SelectInput';
import NumberInput from './NumberInput';

class BufferInput extends React.Component {
    state = {
        // headers: [
        //     {
        //         key: 'Format',
        //         type: 'SelectInput',
        //         col: '12',
        //         information: {
        //             type: 'local',
        //             items: [{ title: 'AM' }, { title: 'PM' }],
        //             label: '',
        //             placeholder: 'Am',
        //             required: true
        //         }
        //     }
        // ],
        // valueInputNumber: '00',
        // valueInputNumber1: '00',
        // valueInputNumber2: '00',
        hours: Array.from({ length: 24 }, (_, i) => ({
            value: i,
            title: `${i} hours`
        })),
        min: Array.from({ length: 12 }, (_, i) => ({
            value: i * 5,
            title: `${i * 5} minutes`
        })),
        defaultValue: { day: 0, hour: 0, min: 0 }
    }



    componentDidMount = () => {
        // this.init()
    }
    componentDidUpdate = (prevProps, prevState) => {
        // if (prevProps.data != this.props.data) {
        //     // console.log('this.props.data', this.props.data)
        //     this.init()
        // }
        // console.log('aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa', this.state.timeData)
    }



    changeInputValue = (key, value, extra) => {

        // console.log(this.props.data)
        let data = this.props.data ?? this.state.defaultValue

        data[key] = value

        // console.log(data)

        this.props.changeValue(this.props.header.key, data, this.props.extra)

    }



    // componentWillUnmount() {
    //     document.removeEventListener('mousedown', this.closeBox);
    //     window.removeEventListener('scroll', this.getPosition);

    // }

    // toggleOpen(disabled) {
    //     if (!disabled) {

    //         // console.log("toggleOpen")

    //         this.fixedView.showView()
    //         this.setState({ isOpen: true })
    //     }
    // }
    // init = () => {
    //     let timeData = {}
    //     console.log('vvvvvvvvtimeDatatimeData',this.props.data)
    //     if (this.props.data) {
    //         let splitted = this.props.data.split(":")

    //         timeData['hour'] = splitted[0] ?? '00'
    //         timeData['min'] = splitted[1] ?? '00'
    //         timeData['sec'] = splitted[2] ?? '00'

    //         Object.entries(timeData)?.map(([timeDataKey, timeDataValue]) => {

    //             if (timeDataValue == 'undefined') {
    //                 timeData[timeDataKey] = '00'
    //             }
    //         })
    //     }
    //     console.log('vvvvvvvvtimeDatatimeData',timeData)
    //     this.setState({ timeData })
    // }
    // init = () => {
    //     let timeData = {}
    //     let data = this.props.data ? this.props.data : '00:00:00'
    //     let splitted = data.split(":")

    //     timeData['hour'] = splitted[0] ?? '00'
    //     timeData['min'] = splitted[1] ?? '00'
    //     timeData['sec'] = splitted[2] ?? '00'

    //     Object.entries(timeData)?.map(([timeDataKey, timeDataValue]) => {

    //         if (timeDataValue == 'undefined') {
    //             timeData[timeDataKey] = '00'
    //         }
    //     })

    //     this.setState({ timeData })
    // }

    // setWrapperRef(node) {
    //     this.wrapperRef = node;
    // }

    setTime = (key, value) => {
        let timeData = this.state.timeData ?? {}
        let data = this.props.data ? this.props.data : '00:00:00'
        let splitted = data.split(":")
        timeData['hour'] = splitted[0] ?? '00'
        timeData['min'] = splitted[1] ?? '00'
        timeData['sec'] = splitted[2] ?? '00'
        // if (value == '') {
        //     value = '00'
        // }
        // console.log("timeData", timeData)
        timeData[key] = value

        Object.entries(timeData)?.map(([timeDataKey, timeDataValue]) => {

            if (timeDataValue == 'undefined') {
                timeData[timeDataKey] = '00'
            }
        })

        // console.log('valueobject', value)
        this.setState({ timeData }, () => {

            let timeDataStr = `${timeData['hour'] == '' ? '00' : timeData['hour']}:${timeData['min'] == '' ? '00' : timeData['min']}:${timeData['sec'] == '' ? '00' : timeData['sec']}`
            if (this.props.changeValue) {
                // console.log('this.props.changeValue', this.props.header.key, timeDataStr)
                this.props.changeValue(this.props.header.key, timeDataStr)
            }
        })
    }

    render() {
        // let time = this.props.data;
        let info = this.props.header?.information
        const { hours, min } = this.state;
        // if (!time) time = moment()

        // console.log(this.props.data)
        return (
            <div className='mt-0 w-100 h-100 flexc'>
                <div className='position-relative w-100' >
                    <div ref={el => this.currentNode = el} disabled={info?.disabled} className='flexc' defaultValue={this.state.timeData} placeholder={info?.placeHolder} style={{ height: '100%', color: '#222', }} >
                        {/* {this.props.data && (<p className="input-text no-wrap date-text">{(this.props.data && info.seconds) ? this.props.data : (this.props.data && !info.seconds) ? this.props.data.slice(0, 5) : ''}</p>)} */}
                        {/* {!this.state.timeData && (<p className="w-100 placeholder" style={{}}>{info?.placeholder ? checkTranslation(info?.placeholder) : translate("Select ...")}</p>)} */}
                        {/* {console.log(this.state.timeData)} */}
                        {!info.noDay && (
                            <>
                                <div className='bordered-input flexc  w-100' >
                                    <NumberInput data={this.props.data?.day} header={{ key: 'day', information: { placeholder: '0' } }} changeValue={this.changeInputValue} />
                                </div>
                                <p className='mx-2 font-size-15'>{translate("Days")}</p>
                            </>
                        )}
                        <div className='bordered-input flexc  mrd-2 w-100' >
                            <SelectInput data={this.props.data?.hour} header={{ key: 'hour', information: { type: 'local', items: hours, placeholder: '{{lang}}0 Hours', required: true } }} changeValue={this.changeInputValue} />
                        </div>

                        <div className='bordered-input flexc  w-100' >
                            <SelectInput data={this.props.data?.min} header={{ key: 'min', information: { type: 'local', items: min, placeholder: '{{lang}}0 Minutes', required: true } }} changeValue={this.changeInputValue} />
                        </div>

                        {/* {this.state.timeData &&
                            <>
                                <input ref={el => this.hRef = el} disabled={info?.disabled} style={{ color: info?.disabled ? '#7c7c7c' : '#000', width: "21px ", cursor: info?.disabled ? 'not-allowed' : 'text', border: 'none', background: "transparent" }} placeholder={this.state.timeData?.hour ?? '00'} type='text' name="number" maxLength={2} value={this.state.timeData?.hour}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        if (value < 24) {
                                            if (/^\d{0,2}$/.test(value)) {
                                                this.setTime('hour', value);
                                                this.setState({ valueInputNumber: value }, () => {
                                                    if (value?.length === 2) {
                                                        this.mRef.focus()
                                                    }
                                                })
                                            }
                                        }

                                    }}
                                    onBlur={(e) => {
                                        const value = this.state.valueInputNumber
                                        if (value.length === 1 && value != 0) {
                                            this.setTime('hour', `0${value}`);
                                        }
                                    }} />
                                <p className='px-1'>:</p>
                                <input ref={el => this.mRef = el} disabled={info?.disabled} style={{ color: info?.disabled ? '#7c7c7c' : '#000', width: "21px ", cursor: info?.disabled ? 'not-allowed' : 'text', border: 'none', background: "transparent" }} placeholder={this.state.timeData.min ?? '00'} type='text' name="number" maxLength={2} value={this.state.timeData?.min ?? '00'}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        // console.log('vlureeee3434:', value)
                                        if (value < 60) {
                                            if (/^\d{0,2}$/.test(value)) {
                                                this.setTime('min', value);
                                                this.setState({ valueInputNumber1: value }, () => {
                                                    if (value?.length === 0) {
                                                        this.hRef.focus()
                                                    } else if ((value?.length === 2) && info?.seconds) {
                                                        this.sRef.focus()
                                                    }
                                                })
                                            }
                                        }

                                    }}
                                    onBlur={(e) => {
                                        const value = this.state.valueInputNumber1
                                        if (value.length === 1 && value != 0) {
                                            this.setTime('min', `0${value}`);
                                        }
                                    }} />
                                {info.seconds &&
                                    <>
                                        <p className='px-1'>:</p>
                                        <input ref={el => this.sRef = el} disabled={info?.disabled} style={{ color: info?.disabled ? '#7c7c7c' : '#000', width: "21px ", cursor: info?.disabled ? 'not-allowed' : 'text', border: 'none', background: "transparent" }} placeholder='00' type='text' name="number" maxLength={2} value={this.state.timeData?.sec ?? '00'}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                if (value < 60) {
                                                    if (/^\d{0,2}$/.test(value)) {
                                                        this.setTime('sec', value);
                                                        this.setState({ valueInputNumber2: value }, () => {
                                                            if (value?.length === 0) {
                                                                this.mRef.focus()
                                                            }
                                                        })
                                                    }
                                                }

                                            }}
                                            onBlur={(e) => {
                                                const value = this.state.valueInputNumber2
                                                if (value.length === 1 && value != 0) {

                                                    this.setTime('sec', `0${value}`);
                                                }
                                            }} />
                                    </>}
                            </>} */}
                    </div>
                    {/* <FixedView ref={el => this.fixedView = el} nodeRef={this.currentNode} onHide={this.onHide} topOffset={8} bottomOffset={0} zIndex={10} xOffset={0} rightAlign={false}> */}

                    {/* <FixedView ref={el => this.fixedView = el} nodeRef={this.currentNode} topOffset={8} bottomOffset={25} zIndex={10} xOffset={-5} >
                        <div className="bg-white box-shadow-20 br-5 flexcb w-100 mt-2" style={{ maxHeight: '150px', minWidth: info?.seconds ? '200px' : "130px", borderRadius: "10px", }}>

                            <div className="" style={{ maxHeight: '150px', minWidth: '65px', borderRight: '1px solid #f3f3f3' }}>
                                <div className="font-size-14 flexcc" style={{ height: '30px', position: 'sticky', top: 0, background: '#fff', color: '#202020', fontWeight: "bold", borderRadius: '10px 0 0 0', }}>Hour</div>
                                <div className='scroll-no-scrollbar px-2' style={{ maxHeight: '120px', minHeight: '20px', backgroundColor: '#fff' }} >
                                    {hours.map((item, index) => (

                                        <div style={{ background: this.props?.data?.split(":")[0] == item ? "rgb(242, 242, 242)" : "#fff" }} className="flexcc w-100 cursor-pointer hover-fields br-8" key={index} onClick={() => { this.setState({ valueInputNumber: item }); this.setTime('hour', item); }}>
                                            <p className="font-size-14" style={{ color: '#333', }}>{item}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            <div className="" style={{ maxHeight: '150px', minWidth: '65px', borderRight: info?.seconds ? '1px solid #f3f3f3' : 0 }}>
                                <div className="font-size-14 flexcc" style={{ height: '30px', position: 'sticky', top: 0, background: '#fff', color: '#202020', fontWeight: "bold", width: info?.seconds ? "72px" : '60px' }}>Minute</div>
                                <div className='scroll-no-scrollbar px-2' style={{ maxHeight: '120px', minHeight: '20px', backgroundColor: '#fff' }}>

                                    {min.map((item, index) => (
                                        <div style={{ background: this.props?.data?.split(":")[1] == item ? "rgb(242, 242, 242)" : "#fff" }} className="flexcc w-100 cursor-pointer hover-fields br-8" key={index} onClick={() => { this.setState({ valueInputNumber1: item }); this.setTime('min', item); }}>
                                            <p className="font-size-14" style={{ color: '#333', }}>{item}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {info?.seconds && <div className="scroll-no-scrollbar py-1 px-2" style={{ maxHeight: '150px', minWidth: '65px' }}>
                                <div className="font-size-14 flexcc" style={{ width: "52px", background: '#fff', position: 'fixed', top: "8px", color: '#202020', fontWeight: "bold", borderRadius: '0 10px 0 0' }}>Second</div>
                                <div style={{ minHeight: '20px' }} />

                                {min.map((item, index) => (
                                    <div style={{ background: this.props?.data?.split(":")[2] == item ? "rgb(242, 242, 242)" : "#fff" }} className="flexcc w-100 cursor-pointer hover-fields br-8" key={index} onClick={() => { this.setState({ valueInputNumber2: item }); this.setTime('sec', item) }}>
                                        <p className="font-size-14" style={{ color: '#333', }}>{item}</p>
                                    </div>
                                ))}
                            </div>}
                        </div>
                    </FixedView> */}
                </div>
            </div>
        );
    }
}

export default BufferInput;
